const SendPoundsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.8333 9.99996H17.5M17.5 9.99996L14.3 6.66663M17.5 9.99996L14.3 13.3333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83331 10.8334C5.27776 12.2223 4.44442 13.6112 3.33331 14.1667H8.61109C8.61109 14.1667 9.44442 14.1667 9.99998 13.6112"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.05556 10.8334H2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M9.16669 8.33337C9.16669 6.95266 8.0474 5.83337 6.66669 5.83337C5.28598 5.83337 4.16669 6.95266 4.16669 8.33337C4.16669 9.71409 5.28598 10.8334 6.66669 10.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SendPoundsIcon;
